// removed by extract-text-webpack-plugin
module.exports = {"tiny":"380px","mobile":"768px","medium":"769px","large":"1024px","white":"#ffffff","whiteSmoke":"#f1f1f1","whiteFog":"#f9f9f9","whiteGrey":"#d8d8d8","black":"#262626","grey":"#9d9d9d","lightGrey":"#ccc","primary":"#32509e","secondary":"#32509e","tertiary":"#d61b22","quaternary":"#d61b22","error":"#e32438","success":"#79d38a","inactive":"#c6c6c6","billPrimary":"#077bc2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/ebon/EbonSelectorComponent.scss
// module id = 1330
// module chunks = 0